import { AppIcon, type College } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Button, Tooltip } from '@mui/material';

import { myCollegeTooltip, useMyCollegeToggle } from './useMyCollegeToggle';

const STRINGS = appStrings.modules.myColleges;

type AddToMyCollegesButtonProps = Readonly<{
  college: College;
  id?: string;
  fullWidth?: boolean;
}>;

export const AddToMyCollegesButton = ({
  college,
  id = 'college-my-colleges-btn',
  fullWidth = false,
}: AddToMyCollegesButtonProps) => {
  const myCollege = useMyCollegeToggle(college);
  const { isAvailable, isInMyColleges, toggle } = myCollege;

  if (!isAvailable) return null;

  const tooltip = myCollegeTooltip(myCollege);

  return (
    <Tooltip title={tooltip}>
      <Button
        id={id}
        hierarchy="Secondary gray"
        size="md"
        fullWidth={fullWidth}
        aria-label={isInMyColleges ? STRINGS.removeAriaLabel(college.school_name) : undefined}
        onClick={toggle}
        startIcon={
          <AppIcon
            iconName={isInMyColleges ? 'CheckCircle' : 'GraduationHat02'}
            color="currentColor"
            diameter="16px"
          />
        }
      >
        {isInMyColleges ? STRINGS.inList : STRINGS.add}
      </Button>
    </Tooltip>
  );
};
